module.exports = __webpack_public_path__ + "img/myluxura-logo.light.ad228d07.svg";